<template>
    <b-row>
        <b-col md="4" cols="12">
            <info-card
            label="الجهة المقدمة للمعاملة"
            :value="ngo.name_ar"
            />
        </b-col>
        <b-col md="4" cols="12">
            <info-card label=" المقر" :value="ngo.hq.name_ar" />
        </b-col>
        <b-col md="4" cols="12">
            <info-card
            label="الشكل القانوني للجهة المقدمة للمعاملة"
            :value="ngo.legalForm.name_ar"
            />
        </b-col>

        <b-col cols="4" v-if="$router.currentRoute.path.includes('ministry') && ngo.internal_system_file">
            <div class="info-card px-2 py-1 my-1">
            <div class="d-flex align-items-center justify-content-between">
                <div>
                    النظام الداخلي / الأساسي
                </div>
                <div>
                <b-button
                
                    variant="flat-info"
                    v-b-toggle.doc-view
                    class="btn-icon mx-25"
                    v-b-tooltip.hover.v-info.bottom
                    title="عرض المستند المرفوع"
                    :to="{ name: 'file-view', query: { ep:ngo.internal_system_file.source  } }"
                >
                    <feather-icon icon="EyeIcon"
                /></b-button>
                </div>
            </div>
            <div>
                <hr />
            </div>
            </div>
        </b-col> 

        <b-col cols="4" v-if="$router.currentRoute.path.includes('ministry') && ngo.decision_file">
            <div class="info-card px-2 py-1 my-1">
            <div class="d-flex align-items-center justify-content-between">
                <div>
                قرار الإشهار
                </div>
                <div>
                <b-button
                
                    variant="flat-info"
                    v-b-toggle.doc-view
                    class="btn-icon mx-25"
                    v-b-tooltip.hover.v-info.bottom
                    title="عرض المستند المرفوع"
                    :to="{ name: 'file-view', query: { ep:ngo.decision_file.source  } }"
                >
                    <feather-icon icon="EyeIcon"
                /></b-button>
                </div>
            </div>
            <div>
                <hr />
            </div>
            </div>
        </b-col> 
        <b-col md="4" cols="12" v-if="user">
            <info-card label=" مقدم المعاملة" 
            :value="user.full_name" />
        </b-col>
    </b-row>
</template>

<script>
import { BCol , BRow , VBToggle , VBTooltip , BButton } from "bootstrap-vue";
import InfoCard from "@/components/InfoCard.vue";
export default {
    components: {
     BCol , InfoCard , BRow , BButton
    },
    props: {
        ngo: Object  ,
        user : Object  ,
    },
    
    directives: {
        "b-toggle": VBToggle,
        "b-tooltip": VBTooltip,
    },
};
</script>